import { DataInput } from '@/types/automationFields.ts';
import { FilterStep, GetFileFromDirectoryStep, IterateStep } from '@/types/automationSteps.ts';
import { useUpdateStepFields } from '@/hooks/api/steps/useUpdateStepFields.ts';
import { StepErrorType } from '@/types/stepErrorTypes.ts';
import useStepSpecificError from '@/hooks/useStepSpecificError.ts';
import SingleDataInputSelectorInner from '@/pages/Editor/components/SharedFields/DataInputSelector/SingleDataInputSelectorInner.tsx';

type props = {
  step: IterateStep | GetFileFromDirectoryStep | FilterStep;
  label?: string;
  errorType?: StepErrorType;
};

type Fields = {
  data_input: DataInput;
};

const SingleDataInputSelector = ({ step, label, errorType }: props) => {
  const { fields, onChangeNoDelay } = useUpdateStepFields<Fields>({ step });

  const dataInputError = useStepSpecificError(step, errorType || StepErrorType.InvalidDataInput);

  return (
    <SingleDataInputSelectorInner
      step={step}
      label={label}
      dataInputError={dataInputError}
      dataInput={fields.data_input}
      onChange={(dataInput) => onChangeNoDelay({ data_input: dataInput })}
    />
  );
};

export default SingleDataInputSelector;
